import { PageHeader, withHTMLHeadSEO } from 'components/common';
import CaseSimulationCommonLanding from 'components/common/case-simulation-common-landing/CaseSimulationCommonLanding';

const CaseStudyLandingPage = () => (
  <div>
    <PageHeader title="SimChart Assignment" />
    <CaseSimulationCommonLanding />
  </div>
);

export { CaseStudyLandingPage as BaseCaseStudyLandingPage };
export default withHTMLHeadSEO({ title: 'Case Study Landing Page' })(CaseStudyLandingPage);
